import { ChangeEvent } from 'react'

import {
  Box, Button, FormField, InputSearch,
} from '@domain-group/suit-theme'

import type {
  UsePublicationBookingPlannerPayload,
} from '@components/PublicationBookingPlanner/hooks/usePublicationBookingPlanner'

import OrderItem from './OrderItem'

interface ItemsProps {
  bookingPlannerPayload: UsePublicationBookingPlannerPayload,
  detailMode: boolean,
}
type SortItemKey = 'agency' | 'price-asc' | 'price-desc' | 'size' | 'suburb'

const Items = (props: ItemsProps) => {
  const {
    bookingPlannerPayload: {
      callbacks: {
        setState,
      },
      editionData: {
        placedOrderItemIds = [],
      },
      filterString,
      filteredOrderItems,
      ordersPayload: {
        callbacks: {
          loadMore,
        },
        canLoadMore,
        loading: loadingOrders,
      },
      sortItemsByKey,
    },
    detailMode,
  } = props

  return (
    <Box flexDirection="column" flexGrow={1} marginTop="large">
      <FormField fieldHolderProps={{ style: { gap: '4px' } }} label="Filter by address or agency">
        {/*
         // @ts-expect-error TS2741 */}
        <InputSearch
          onChange={(e: ChangeEvent<HTMLInputElement>) => setState({ filterString: e.target.value })}
          value={filterString}
        />
  
        <select onChange={e => setState({ sortItemsByKey: e.target.value as SortItemKey})} value={sortItemsByKey}>
          <option value="">Sort Items By...</option>
          <option value="size">Ad Size</option>
          <option value="suburb">Suburb Name</option>
          <option value="agency">Agency Name</option>
          <option value="price-asc">Price (asc)</option>
          <option value="price-desc">Price (desc)</option>
        </select>
      </FormField>

      <Box
        flexDirection="column"
        flexGrow={1}
        flexShrink={1}
        flexBasis="auto"
        height="100px"
        marginTop="medium"
        minHeight="100px"
        overflowY="auto"
        style={{ gap: '4px' }}
      >
        {filteredOrderItems.map(orderItem => (
          <OrderItem
            detailMode={detailMode}
            dragDisabled={placedOrderItemIds.includes(orderItem.id)}
            key={orderItem.id}
            orderItem={orderItem}
          />
        ))}
      </Box>

      {(canLoadMore || loadingOrders) && (
        <Button
          buttonStyle="secondaryUtility"
          loading={loadingOrders}
          onClick={loadMore}
          size="medium"
        >
          Load More
        </Button>
      )}
    </Box>
  )
}

export default Items
